import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

const useQuickSearchFields = () => {
  const updateQuickSearchFields = useMutation({
    mutationFn: ({
      moduleAPIName,
      quickSearchFields,
      onSuccess,
    }: {
      moduleAPIName: string;
      quickSearchFields: any;
      onSuccess?: () => void;
    }) => {
      return TenantAPI.modifyQuickSearchFields(
        moduleAPIName,
        quickSearchFields
      ).then(() => {
        callFunctionIfExists(onSuccess);
      });
    },
  });

  return {
    updateQuickSearchFields: updateQuickSearchFields.mutate,
    loading: updateQuickSearchFields.isPending,
    error: updateQuickSearchFields.error
      ? getErrorMessage(updateQuickSearchFields.error)
      : null,
  };
};
export default useQuickSearchFields;
